import styled from 'styled-components'
import { BREAKPOINTS } from 'resources'

export const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 550px;
`

export const Title = styled.span`
  font-family: 'Druk', sans-serif;
  font-size: 60px;
  line-height: 1;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 70px;
  }
`

export const Description = styled.div`
  margin-top: 20px;
  font-size: 18px;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 20px;
  }
`
